import formEmbeddableMixin from "@/mixins/embeddable/resource/formEmbeddableMixin";
import StockProductManualFormEmbeddable
    from "@/views/modules/stock/StockProduct/embeddable/StockProductManualFormEmbeddable";


export default {
    components: {StockProductManualFormEmbeddable},
    mixins: [formEmbeddableMixin],
    data() {
        return {
            path: "stock/product", //Override somente de front-end, por tanto irá utilizar o mesmo path que o original da página 56
            form: {
                inOutType: 0,
                stockPlaceProductInsideId: 0,
                productId: 0,
                companyId: 0,
                stockManualId: 0,
                issueDate: "",
                quantity: 0,
                stockManualNote: "",
                originCodeLabel: "",
                producedWeight: 0.0,
                enableChooseOut: true,
                sourceOut: [],
            },
            sourceOrderBy: "originCodeLabel",
            fields: [
                {key: "originCodeLabel", label: "Origem"},
                {key: "productName", label: "Produto"},
                {key: "quantityAvailable", label: "Qtd. Disponível", formatter: "number"},
            ],
        }

    },
    /*created(){
        this.form =
    },*/
    methods: {}
}